import * as i0 from '@angular/core';
import { EventEmitter, Component, ChangeDetectionStrategy, Input, Output, NgModule } from '@angular/core';
import * as i1 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import * as i2 from '@angular/material/icon';
import { MatIconModule } from '@angular/material/icon';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';

class FsClearElementComponent {
    constructor(_el) {
        this._el = _el;
        this.show = false;
        this.visible = false;
        this.clear = new EventEmitter();
    }
    ngAfterViewInit() {
        this._el.nativeElement.parentElement.parentElement.parentElement
            .appendChild(this._el.nativeElement.querySelector('.fs-clear-wrapper'));
    }
    clearClick(event) {
        this.clear.emit(event);
    }
}
FsClearElementComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: FsClearElementComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
FsClearElementComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: FsClearElementComponent, selector: "fs-clear", inputs: { show: "show", visible: "visible" }, outputs: { clear: "clear" }, ngImport: i0, template: "<div class=\"mat-form-field-suffix fs-clear-wrapper\">\n  <ng-container *ngIf=\"show\">\n    <button\n        type=\"button\"\n        [tabIndex]=\"-1\"\n        [ngClass]=\"{ visible: visible }\"\n        (click)=\"clearClick($event)\"\n        mat-icon-button>\n      <mat-icon>\n        clear\n      </mat-icon>\n    </button>\n  </ng-container>\n</div>", styles: ["::ng-deep .mat-form-field.mat-form-field-appearance-legacy .fs-clear-wrapper button mat-icon{line-height:normal;font-size:20px!important}::ng-deep .mat-form-field.mat-form-field-appearance-standard .fs-clear-wrapper button{position:relative;top:5px}::ng-deep .fs-clear-wrapper button{cursor:pointer;visibility:hidden}::ng-deep .fs-clear-wrapper button.visible{visibility:visible}\n"], components: [{ type: i1.MatButton, selector: "button[mat-button], button[mat-raised-button], button[mat-icon-button],             button[mat-fab], button[mat-mini-fab], button[mat-stroked-button],             button[mat-flat-button]", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }, { type: i2.MatIcon, selector: "mat-icon", inputs: ["color", "inline", "svgIcon", "fontSet", "fontIcon"], exportAs: ["matIcon"] }], directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: FsClearElementComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'fs-clear',
                    templateUrl: './clear-element.component.html',
                    styleUrls: ['./clear-element.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { show: [{
                type: Input
            }], visible: [{
                type: Input
            }], clear: [{
                type: Output
            }] } });

class FsClearComponent {
    constructor() {
        this.ngModel = null;
        this.fsClear = true;
        this.ngModelChange = new EventEmitter();
        this.cleared = new EventEmitter();
    }
    clear(event) {
        this.ngModelChange.emit(null);
        this.cleared.emit(event);
    }
}
FsClearComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: FsClearComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
FsClearComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: FsClearComponent, selector: "[fsClear]", inputs: { ngModel: "ngModel", fsClear: "fsClear" }, outputs: { ngModelChange: "ngModelChange", cleared: "cleared" }, ngImport: i0, template: "<fs-clear \n  (clear)=\"clear($event)\" \n  [show]=\"fsClear !== false\" \n  [visible]=\"!!ngModel\">\n</fs-clear>", styles: [""], components: [{ type: FsClearElementComponent, selector: "fs-clear", inputs: ["show", "visible"], outputs: ["clear"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: FsClearComponent, decorators: [{
            type: Component,
            args: [{
                    selector: '[fsClear]',
                    templateUrl: './clear.component.html',
                    styleUrls: ['./clear.component.scss'],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], propDecorators: { ngModel: [{
                type: Input
            }], fsClear: [{
                type: Input
            }], ngModelChange: [{
                type: Output
            }], cleared: [{
                type: Output
            }] } });

class FsClearModule {
    static forRoot() {
        return {
            ngModule: FsClearModule
        };
    }
}
FsClearModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: FsClearModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
FsClearModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: FsClearModule, declarations: [FsClearComponent,
        FsClearElementComponent], imports: [CommonModule,
        MatIconModule,
        MatButtonModule], exports: [FsClearComponent,
        FsClearElementComponent] });
FsClearModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: FsClearModule, imports: [[
            CommonModule,
            MatIconModule,
            MatButtonModule
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: FsClearModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        MatIconModule,
                        MatButtonModule
                    ],
                    exports: [
                        FsClearComponent,
                        FsClearElementComponent
                    ],
                    declarations: [
                        FsClearComponent,
                        FsClearElementComponent
                    ]
                }]
        }] });

/*
 * Public API Surface of fs-menu
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FsClearComponent, FsClearElementComponent, FsClearModule };
